/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'goal-actions.goal-content-about.edit-description-error-description':
    'Произошла ошибка. Повторите попытку через несколько минут.',
  'goal-content.goal-about-content.description-edit-button': 'Редактировать',
  'goal-content.goal-about-content.description-title': 'Описание',
  'goal-content.goal-about-content.placeholder-description':
    'Кратко опишите, почему эта цель важна и как измеряется успех, чтобы у подписчиков было одинаковое понимание.',
  'goal-content.goal-content-about.edit-description-error-title': 'Не удалось отредактировать описание цели',
  'goal-content.goal-content-update-date.edited': '(отредактировано)',
  'goal-content.goal-content-update-date.edited-tooltip': 'Отредактировано: {date}',
  'goal-content.goal-content-update-date.last-edited-by': '(последний раз редактировалось пользователем {name})',
  'goal-content.goal-content-updates.add-update': 'Добавить обновление',
  'goal-content.goal-content-updates.archived': 'Архивированные',
  'goal-content.goal-content-updates.at-risk': 'В зоне риска',
  'goal-content.goal-content-updates.cancelled': 'Отменено',
  'goal-content.goal-content-updates.completed': 'Выполнено 🎉',
  'goal-content.goal-content-updates.date-changed': 'Изменилась дата',
  'goal-content.goal-content-updates.edit-update': 'Редактировать',
  "goal-content.goal-content-updates.for-date'": 'на {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Последнее обновление',
  'goal-content.goal-content-updates.missed-update-message': 'Нет опубликованных обновлений',
  'goal-content.goal-content-updates.new-due-date': 'Новая дата выполнения',
  'goal-content.goal-content-updates.new-state': 'Новый статус',
  'goal-content.goal-content-updates.no-updates-description': 'Обновлений по цели пока нет.',
  'goal-content.goal-content-updates.off-track': 'С отставанием от графика',
  'goal-content.goal-content-updates.old-due-date': 'Прежняя дата выполнения',
  'goal-content.goal-content-updates.old-state': 'Прежний статус',
  'goal-content.goal-content-updates.on-track': 'По графику',
  'goal-content.goal-content-updates.paused': 'Приостановлено',
  'goal-content.goal-content-updates.pending': 'В ожидании',
  'goal-content.goal-content-updates.previous-updates-title': 'Предыдущие обновления',
  'goal-content.goal-content-updates.share-update': 'Поделиться',
  'goal-content.goal-content-updates.status-changed': 'Изменен статус',
  'goal-content.goal-content-updates.write-update-button': 'Написать обновление',
  'goal-content.goal-update-composer.modal-title': 'Опубликуйте свое обновление',
  'goal-content.goal-update-composer.post-button-label': 'Опубликовать обновление',
};
